import { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'

const START = 1.0
const END = 100.0
const DURATION = 8500

interface IProps {
    isStopped: boolean
    handleStoppedCounter: () => void
}

export const Counter = ({ isStopped, handleStoppedCounter }: IProps) => {
    const [value, setValue] = useState<number>(START)
    const startTimeRef = useRef<number | null>(null)
    const animationFrameRef = useRef<number | null>(null)

    useEffect(() => {
        if (!isStopped) {
            startTimeRef.current = null
            animationFrameRef.current = requestAnimationFrame(step)
        }

        return () => {
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current)
                animationFrameRef.current = null
            }
        }
    }, [isStopped])

    useEffect(() => {
        if (isStopped && animationFrameRef.current) {
            cancelAnimationFrame(animationFrameRef.current)
            animationFrameRef.current = null
        }
    }, [isStopped])

    const step = (timestamp: number) => {
        if (isStopped) return

        if (!startTimeRef.current) startTimeRef.current = timestamp
        const elapsed = timestamp - startTimeRef.current
        const progress = Math.min(elapsed / DURATION, 1)
        const currentValue = START + (END - START) * progress
        setValue(parseFloat(currentValue.toFixed(2)))

        if (progress < 1) {
            animationFrameRef.current = requestAnimationFrame(step)
        } else {
            animationFrameRef.current = null
            handleStoppedCounter()
        }
    }

    return (
        <div className={styles.counter}>
            <div className={styles.text_wrapper}>
                <span className={styles.value}>{value.toFixed(2)}x</span>
            </div>
        </div>
    )
}
